import * as React from 'react';
import { PastOrdersAnalyze, PastOrdersStatus } from '../../Model';
import { Label, ProgressBar, BarSize } from '../../CommonUI';
import { Box } from '../../CommonUI/Layout';
import { Text, LinkText, withTranslations } from 'ilenia';
import { css, StyleSheet } from 'aphrodite';
import { connect } from 'react-redux';

interface ProgressBarsProps {
    status: PastOrdersStatus;
    period: string;
    analyze: PastOrdersAnalyze;
    translations: any;
}

const ProgressBars: React.SFC<ProgressBarsProps> = ({status, period, analyze, translations}) => {
    const {totalOrdersCount, collectedOrderCount, fetchedOrderCount, scheduledOrderCount, reason} = status;
    const {code} = analyze || {code: reason || null};

    const analyzing = totalOrdersCount === undefined;

    const getPercentage = (value: number | undefined, total: number | undefined) => {
        if (!total) {
            return 0;
        }

        return Math.round((value || 0) / total * 100);
    };

    const renderError = (
        <div className={css(styles.errorComponent, styles.errorColor, styles.errorComponentLink)}>
            <LinkText
                id={`enhancedPastOrders.errors.${code}`}
                links={[
                    {
                        href: code === 1001 ? process.env.REACT_APP_B2BPermissionsUrl : process.env.REACT_APP_SupportRequestUrl,
                        target: '_blank',
                    },
                ]}
            />
        </div>
    );

    return (
        <Box>
            <Label
                label="enhancedPastOrders.progressBars.title"
                mb={32}
                interpolations={{
                    period: translations[`pastOrders.pastOrder-${period}`],
                }}
            />
            <Label
                label="enhancedPastOrders.progressBars.shopify.1"
                labelSize={1}
                disabled={analyzing && !collectedOrderCount}
                className={css(!!code && styles.errorColor)}
            />
            <ProgressBar
                percentage={getPercentage(collectedOrderCount, totalOrdersCount)}
                barSize={BarSize.Small}
                error={!!code}
            />
            {code && renderError}
            <Label
                label="enhancedPastOrders.progressBars.shopify.2"
                labelSize={1}
                disabled={analyzing && !fetchedOrderCount}
            />
            <ProgressBar
                smooth={true}
                percentage={getPercentage(fetchedOrderCount, totalOrdersCount)}
                barSize={BarSize.Small}
            />
            <Label
                label="enhancedPastOrders.progressBars.shopify.3"
                labelSize={1}
                disabled={analyzing && !scheduledOrderCount}
            />
            <ProgressBar
                smooth={true}
                percentage={getPercentage(scheduledOrderCount, totalOrdersCount)}
                barSize={BarSize.Small}
            />
            <p className={css(styles.description)}>
                <Text id="enhancedPastOrders.progressBars.description"/>
            </p>
        </Box>
    );
};

const styles = StyleSheet.create({
    description: {
        marginTop: '40px',
    },
    errorComponent: {
        margin: '10px 0',
        fontSize: '14px',
    },
    errorComponentLink: {
        ':nth-child(1n) > a': {
            color: 'rgb(252, 76, 93)',
        }
    },
    errorColor: {
        color: 'rgb(252, 76, 93)',
    }
});

const mapStateToProps = (state: any) => ({
    period: state.PastOrders.period,
    analyze: state.PastOrders.analyze,
    status: state.PastOrders.status,
});

export const ProgressBarsComponent = connect(
    mapStateToProps,
    null
)(withTranslations(ProgressBars));



// WEBPACK FOOTER //
// ./src/Components/EnhancedPastOrders/ProgressBars.tsx